import { Link } from "@remix-run/react";
import type { PropsWithChildren } from "react";
import { RiBox3Line, RiCalculatorLine, RiFileLine, RiGlobalLine } from "react-icons/ri";

import { Wrapper } from "~/components/ui/layout/wrapper";
import { cn } from "~/utils/classnames";

import type { SideMenuProps } from "./SideMenu.types";

/**
 * Composant Menu latéral d'intéraction
 */
export const SideMenu = ({
  productsPageSlug,
  websiteUrl,
  computingToolUrl,
  className,
  ...props
}: SideMenuProps) => {
  const items = [
    { name: "Voir les produits", icon: RiBox3Line, url: productsPageSlug, newTab: false },
    { name: "Documents à télécharger", icon: RiFileLine, url: "#downloads", newTab: false },
    { name: "Visiter le site", icon: RiGlobalLine, url: websiteUrl, newTab: true },
    { name: "Outil de calcul", icon: RiCalculatorLine, url: computingToolUrl, newTab: true },
  ];
  return (
    <div
      className={cn(
        "flex w-fit flex-col flex-wrap items-center justify-center gap-1 rounded-2xl border border-grey-100 bg-white p-1 shadow-md md:gap-2 md:p-2",
        className
      )}
      {...props}
    >
      {items.map((item, index) =>
        item.url ? (
          <Link
            key={index}
            to={item.url}
            target={item.newTab ? "_blank" : "_self"}
            rel={item.newTab ? "noopener noreferrer" : ""}
            className="group flex h-24 w-24 cursor-pointer flex-col items-center justify-center gap-2 rounded-xl p-1 text-center text-xs hover:bg-grey-900 hover:text-white md:w-36 md:p-2 md:text-sm"
          >
            <item.icon className="size-5 shrink-0 text-grey-900 group-hover:text-white md:size-6" />
            <span>{item.name}</span>
          </Link>
        ) : null
      )}
    </div>
  );
};

export const SideMenuLayout = ({
  children,
  className,
  ...props
}: PropsWithChildren<SideMenuProps>) => (
  <div className="relative">
    <Wrapper className="pointer-events-none mb-8 lg:absolute lg:inset-0 lg:mb-0">
      <SideMenu
        className={cn(
          "pointer-events-auto sticky top-40 mx-auto flex-row lg:mx-0 lg:ml-auto lg:flex-col",
          className
        )}
        {...props}
      />
    </Wrapper>
    {children}
  </div>
);

export const SideMenuLayoutWrapper = ({
  children,
  className,
  ...props
}: PropsWithChildren<SideMenuProps>) => (
  <Wrapper className={cn("lg:pr-56 xl:pr-56", className)} {...props}>
    {children}
  </Wrapper>
);
